module.exports = __webpack_public_path__ + "img/ytzg.76f43b64.png";